import React from 'react';
import { PricedStatus } from 'types';

import { Segmented } from '@bettercomp/ui-components';

export const PRICING_OPTIONS = {
  all: { value: PricedStatus.ALL, label: 'All' },
  priced: { value: PricedStatus.PRICED, label: 'Priced' },
  unpriced: { value: PricedStatus.UNPRICED, label: 'Unpriced' },
};

export const PRICING_OPTIONS_MASS = {
  all: { value: PricedStatus.ALL, label: 'All' },
  priced: { value: PricedStatus.PRICED, label: 'Priced' },
  noCuts: { value: PricedStatus.NO_CUTS, label: 'No Cuts' },
};

type PricingStatusSelectorProps = {
  isMass?: boolean,
  value?: PricedStatus,
  onChange: (value: PricedStatus) => void,
  className?: string,
}

export function PricingStatusSelector({ isMass, onChange, ...props }: PricingStatusSelectorProps) {
  return (
    <Segmented
      options={Object.values(isMass ? PRICING_OPTIONS_MASS : PRICING_OPTIONS)}
      onChange={(v) => onChange(v as PricedStatus)}
      data-testid="pricingStatusSelector"
      {...props}
    />
  );
}
